"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormControl = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classNames_1 = require("../../../../../utils/classNames");
const theme_1 = require("../../../../../utils/theme");
const FormControl = ({ name, children, label, hint, error, palette, }) => {
    const theme = (0, theme_1.useTheme)();
    const paletteClasses = [
        ...theme.palette[palette || 'none'].hover,
        ...theme.palette[palette || 'none'].text,
    ];
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex-1 items-center space-y-2", children: [label ? ((0, jsx_runtime_1.jsx)("label", { htmlFor: name, className: (0, classNames_1.cn)('block', theme.typography.variants.menu, paletteClasses, 'text-base'), children: label })) : null, (0, react_1.cloneElement)(children, {
                invalid: error ? true : false,
                id: name,
            }), Boolean(hint && !error) ? ((0, jsx_runtime_1.jsx)("p", { className: "text-sm text-slate-500", children: hint })) : null, Boolean(error) ? ((0, jsx_runtime_1.jsx)("p", { className: "text-sm text-invalid", children: String(error) })) : null] }));
};
exports.FormControl = FormControl;
